import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports-config";
import configureStorage from "./config/storage-config";
import "./i18n"; // Initialize i18n

// Configure Amplify with auth settings
Amplify.configure(awsconfig);

// Configure Storage to use sam-bucket-assets
configureStorage();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
